import { InteractionRequiredAuthError } from '@azure/msal-browser';

import { msalInstance } from '../main';

export const graphConfig = {
	graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me/profile',
};

export const checkSSO = async () => {
	const account = msalInstance.getActiveAccount();
	if (!account) {
		throw new Error(
			'No active account! Verify a user has been signed in and setActiveAccount has been called.',
		);
	}

	// Check if the token will expire in the next 5 minutes (300 seconds)
	const currentTime = Math.floor(Date.now() / 1000);
	const tokenExpiry = account?.idTokenClaims?.exp;
	const bufferTime = 300; // 5 minutes in seconds

	if (!tokenExpiry || tokenExpiry <= currentTime + bufferTime) {
		throw new InteractionRequiredAuthError();
	}

	return account;
};

export const isUserAuthenticated = (): boolean => {
	const account = msalInstance.getActiveAccount();
	if (!account) {
		return false;
	}

	const currentTime = Math.floor(Date.now() / 1000);
	const tokenExpiry = account?.idTokenClaims?.exp;

	return tokenExpiry ? tokenExpiry > currentTime : false;
};

export const logout = async () => {
	await msalInstance.logoutRedirect();
};
